import { OverflowLite } from '@sas/react-svg';
import { createElement, Fragment } from 'react';
import { TileHeaderProps } from '.';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import { postfixTestId } from '../../../util/testId';
import { ButtonVariant } from '../../Button';
import { Heading } from '../../Heading';
import { Icon } from '../../Icon';
import { Link } from '../../Link';
import { MenuButton } from '../../MenuButton';
import { Text } from '../../Text';

import cx from 'classnames';
import cn from './TileHeader.css.json';
import './TileHeader.css';

export const TileHeader = (props: TileHeaderProps) => {
  const dt = useDesignTokens();

  const tokens = renderInlineCssVars(
    {
      'spacing-xs': dt.spacing.core.xs,
      'spacing-s': dt.spacing.core.s,
      'spacing-m': dt.spacing.core.m,
      'icon-fg': dt.stateStandardNova.normal.fg,
      'font-size-m': dt.fontNova.size.m,
      'font-weight-thick': dt.fontNova.weight.thick,
    },
    'tile-header'
  );

  return (
    <Fragment>
      <div className={cn.container} style={tokens}>
        {props.icon ? (
          <Icon
            {...props.icon}
            testId={postfixTestId(props.testId, 'object-icon')}
            className={cx(
              props.icon.className,
              props.title && props.subTitle ? cn.iconWithSubtitle : cn.icon
            )}
            tabIndex={props.isInteractive && !props.objectIconAriaHidden ? 0 : undefined}
            tokens={() => ({ fg: 'var(--tile-header-icon-fg)' })}
          />
        ) : null}
        {props.title ? (
          <Fragment>
            {props.onOpen && !props.suppressTitleAsLink ? (
              <Link
                id={props.titleId}
                tabIndex={props.isInteractive ? 0 : -1}
                onPress={() => {
                  props.onOpen?.();
                }}
                wrapText={false}
                decoration="hover-only"
                className={cn.title}
                testId={postfixTestId(props.testId, 'link')}
              >
                {props.title}
              </Link>
            ) : (
              <Heading
                focusable={props.isInteractive}
                id={props.titleId}
                level={3}
                wrapText={false}
                className={cn.title}
                testId={postfixTestId(props.testId, 'title-heading')}
              >
                {props.title}
              </Heading>
            )}
            {props.subTitle ? ( // subTitle is only shown when props.title is provided
              <Heading
                level={5}
                focusable={props.isInteractive}
                wrapText={false}
                className={cn.subtitle}
                testId={postfixTestId(props.testId, 'subtitle-heading')}
              >
                {props.subTitle}
              </Heading>
            ) : null}
          </Fragment>
        ) : null}
        {props.menuButtonProps ? (
          <div className={cn.menuButtonContainer}>
            <MenuButton
              {...props.menuButtonProps}
              focusable={props.isInteractive}
              hideDownArrow
              variant={ButtonVariant.Icon}
              icon={{ icon: OverflowLite }}
              testId={postfixTestId(props.testId, 'menuButton')}
            />
          </div>
        ) : null}
      </div>
      {props.description ? (
        <Text
          tabIndex={props.isInteractive ? 0 : undefined}
          testId={postfixTestId(props.testId, 'description')}
        >
          {props.description}
        </Text>
      ) : null}
    </Fragment>
  );
};
